<template>
  <div class="page-wrapper">

    <!-- 顶部信息 -->
    <div class="top-wrapper">
      <div class="content">
        <div class="left">
          <img :src="ajaxUrl.readFile(companyDetails.photoUrl)" alt="公司封面" class="img">
          <div class="info">
            <div class="top">
              <label>
                {{ companyDetails.name }}
                <img v-if="companyDetails.isSchool === '1'" src="../../assets/img/icon/icon_xz_PC.png" alt="" />
              </label>
              <span>{{ companyDetails.typeStr }}</span>
            </div>
            <div class="bottom">
              <span>{{ companyDetails.establishedTime | dateFormatFun }}成立</span>
              <span>{{ companyDetails.natureStr }}</span>
              <span>{{ companyDetails.scaleStr }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <ul>
            <li style="cursor: pointer" @click="goto('list')">
              <span>{{ companyDetails.effectivePostNum }}</span>
              <label>在招职位</label>
            </li>
<!--            <li>-->
<!--              <span>{{ companyDetails.countInviteNum }}</span>-->
<!--              <label>共邀面试</label>-->
<!--            </li>-->
          </ul>
        </div>
      </div>
    </div>

    <!-- 正文信息 -->
    <div class="main-wrapper">
      <div class="title">企业简介</div>
      <div v-if="companyDetails && companyDetails.description" class="content" v-html="companyDetails.description.replace(/\n/g, '<br/>')"></div>
      <div class="title">企业地址</div>
      <div class="companyLocation">{{ companyDetails.areaName | cityFmt }} {{ companyDetails.address }}</div>
      <!-- <div id="map" class="map"></div> -->
      <div id="list" class="title">职位招聘</div>
      <div class="list-wrapper" v-loading="loading">
        <list-item
            class="listItem"
            v-for="(item, index) in workList"
            :key="index"
            :item="item"
            :secInfoShow="false"
            @click="workDetails(item.id)"
        >
          <!-- <div slot="mainInfo">{{ item.updateTime | dateFormatFun }} 更新</div> -->
          <div v-if="!$store.state.user.userType || $store.state.user.userType === 1" slot="btnInfo" class="btnInfo" style="display: block;">
            <div v-if="Number(item.applied) === 0" style="margin-top: 26px;" class="apply" @click.stop="applySubmit(item.id)">申请职位</div>
            <div v-if="Number(item.applied) === 1" style="margin-top: 26px;" class="apply applied">已投递</div>
            <div v-show="Number(item.collected) === 0" style="margin: 10px 0 0 45px;" class="collection" @click.stop="collectionSubmit(item.id)"><i></i>收藏</div>
            <div v-show="Number(item.collected) === 1" style="margin: 10px 0 0 45px;" class="collection collected" @click.stop="delCollectionSubmit(item.id)"><i></i>已收藏</div>
          </div>
        </list-item>
        <div v-show="workList.length <= 0" class="rd-noData">
          <img src="../../assets/img/pic/pic_wuxinxi.png" alt="暂无信息">
          <label>暂无信息</label>
        </div>
      </div>
      <div v-show="workList.length > 0" class="pagination-wrapper">
        <el-pagination
            :current-page="page.currentPage"
            :total="page.total"
            background
            layout="prev, pager, next"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 申请职位成功 -->
    <el-dialog :visible.sync="dialog_applySuccess" title="职位申请" width="500px">
      <div class="rd-success">
        <img class="pic_success" src="../../assets/img/pic/pic_icon_chengggong.png" alt="成功">
        <label>职位申请成功</label>
        <span>请静候佳音，您可以在 <b @click="pRecord">投递记录</b>中查看</span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import * as ajaxUrl from '../../ajax.config.js';
  import ListItem from '../../components/ListItem/ListItem';

  export default {
    name: 'companyDetails',
    data() {
      return {
        ajaxUrl: ajaxUrl,
        companyDetails: '', // 公司信息
        loading: false,
        dialog_applySuccess: false,
        page: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        workList: [] // 职位招聘列表
      };
    },
    components: { ListItem },
    mounted() {
      this.dataLoad();
      this.getWorkList();
    },
    methods: {
      goto(str) {
        document.getElementById(str).scrollIntoView(true);
      },
      dataLoad() {
        this.$get(ajaxUrl.getCompanyById, { companyId: this.$route.query.id }).then((res) => {
          this.companyDetails = res;
          // this.getMap(res.areaName, res.address);
        });
      },
      // 生成百度地图
      getMap(city, address) {
        city = city.split(';')[city.split(';').length - 1];
        this.$nextTick(() => {
          const map = new BMap.Map('map');
          const myGeo = new BMap.Geocoder();
          map.addControl(new BMap.NavigationControl());
          map.addControl(new BMap.ScaleControl());
          map.addControl(new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_SMALL }));
          myGeo.getPoint(address, (point) => {
            if (point) {
              map.centerAndZoom(point, 17);
              map.addOverlay(new BMap.Marker(point));
            }
          }, city);
        });
      },
      // 获取职位招聘列表
      getWorkList() {
        const params = {
          companyId: this.$route.query.id,
          page: this.page.currentPage,
          size: this.page.pageSize
        };
        this.loading = true;
        this.$get(ajaxUrl.getCompanyPostList, params).then((res) => {
          this.loading = false;
          this.workList = res.content;
          this.page.total = res.totalElements;
        });
      },
      // 翻页
      handlePageChange(val) {
        this.page.currentPage = val;
        this.getWorkList();
      },
      // 取消收藏提交
      delCollectionSubmit(id) {
        this.$get(ajaxUrl.delCollectPost, { id: id }).then((res) => {
          this.$message({
            message: '职位已取消收藏',
            type: 'success'
          });
          this.getWorkList();
        });
      },
      // 收藏提交
      collectionSubmit(id) {
        if (!this.$store.state.user.id) {
            this.$message({
                type: 'warning',
                message: '请先登录'
            });
            setTimeout(() => {
              this.$router.push({ path: 'login' });
            }, 500);
            return false;
        };
        this.$get(ajaxUrl.collectionPost, { ids: id }).then((res) => {
          this.$message({
            message: '职位收藏成功',
            type: 'success'
          });
          this.getWorkList();
        });
      },
      // 申请职位
      applySubmit(id) {
        this.$confirm('您确认要申请该职位吗？', '职位申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (!this.$store.state.user.id) {
              this.$message({
                  type: 'warning',
                  message: '请先登录'
              });
              this.$router.push({ path: 'login' });
              return false;
          };
          this.$get(ajaxUrl.applyPost, { ids: id }).then((res) => {
            this.dialog_applySuccess = true;
            this.getWorkList();
          });
        });
      },
      // 跳转到个人账户-投递记录
      pRecord() {
        this.dialog_applySuccess = false;
        const { href } = this.$router.resolve({ name: 'pRecord' });
        window.open(href, '_blank');
      },
      // 跳转到招聘详情页
      workDetails(id) {
        const { href } = this.$router.resolve({ name: 'workDetails', query: { id: id } });
        window.open(href, '_blank');
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "companyDetails.sass"
  @import "../search/search.sass"
</style>
